import { sellHttpApi } from "api";

type RequestPostPackageDataT = {
  donateUnsoldItems: boolean;
  shouldSchedulePickup: boolean;
};

export function requestPostPackage(data: RequestPostPackageDataT) {
  return sellHttpApi.makeAuthenticatedRequest<{ _id: string }>("/packages", {
    method: "POST",
    body: data
  });
}
